<template>
  <el-header class="top-nav">
    <div class="nav-content">
      <div
        class="brand"
        @click="$router.push({ name: isManagementShellNav ? 'console' : 'home' })"
      >灵光云</div>
      <el-menu
        v-if="userStore.isLoggedIn"
        :default-active="menuActiveIndex"
        mode="horizontal"
        class="top-menu"
        background-color="transparent"
        :ellipsis="false"
        :router="false"
        @select="onSelectMenu"
      >
        <el-menu-item
          v-if="!isManagementShellNav"
          index="home"
        >AI对话</el-menu-item>
        <el-menu-item
          v-if="!isManagementShellNav"
          index="ai-draw"
        >AI绘画</el-menu-item>
        <el-menu-item v-if="userStore.hasPermission('prompts')" index="prompts">对话角色管理</el-menu-item>
        <el-menu-item
          v-if="isManagementShellNav && userStore.hasPermission('draw_styles')"
          index="draw-styles-settings"
        >绘画风格管理</el-menu-item>
        <el-menu-item v-if="userStore.hasPermission('knowledge')" index="knowledge">知识库</el-menu-item>
      </el-menu>
      <div class="user-area" v-if="userStore.isLoggedIn">
        <!-- 管理面板按钮 -->
        <el-button 
          v-if="userStore.hasPermission('user_management')" 
          text 
          @click="$router.push({ name: 'admin' })"
          class="admin-btn"
        >
          <el-icon><Monitor /></el-icon>
          管理面板
        </el-button>
        
        <!-- 用户下拉：灵光点与用户名同在头像旁 -->
        <el-dropdown @command="handleUserCommand">
          <span class="user-info">
            <el-avatar :size="32" class="user-avatar-el">
              <el-icon><User /></el-icon>
            </el-avatar>
            <div class="user-meta">
              <span class="username">{{ userStore.user?.username }}</span>
              <span
                v-if="userStore.lingguangBalance !== null"
                class="lg-in-avatar"
                title="灵光点余额"
              >灵光 {{ userStore.lingguangBalance }}</span>
            </div>
            <el-icon class="dropdown-icon"><ArrowDown /></el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="settings">
                <el-icon><Setting /></el-icon>
                设置
              </el-dropdown-item>
              <el-dropdown-item divided command="logout">
                <el-icon><SwitchButton /></el-icon>
                退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>

    </div>
  </el-header>
</template>

<script>
import { useRouter, useRoute } from 'vue-router'
import { computed, watch, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useUserStore } from '@/stores/user'
import { authService } from '@/services/auth'
import {
  User, ArrowDown, Setting, Monitor, SwitchButton
} from '@element-plus/icons-vue'

export default {
  name: 'TopNav',
  components: {
    User, ArrowDown, Setting, Monitor, SwitchButton
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const userStore = useUserStore()

    const MANAGEMENT_SHELL_ROUTE_NAMES = [
      'settings',
      'draw-styles-settings',
      'admin',
      'prompts',
      'knowledge',
      'knowledge-create',
      'knowledge-documents',
      'document-chunks'
    ]

    const isManagementShellNav = computed(() =>
      MANAGEMENT_SHELL_ROUTE_NAMES.includes(route.name)
    )

    const menuActiveIndex = computed(() => {
      const n = route.name
      if (['knowledge', 'knowledge-create', 'knowledge-documents', 'document-chunks'].includes(n)) {
        return 'knowledge'
      }
      return n ? String(n) : ''
    })

    const refreshLingguang = () => {
      if (userStore.isLoggedIn) userStore.fetchLingguangBalance()
    }
    onMounted(refreshLingguang)
    watch(() => userStore.isLoggedIn, (ok) => {
      if (ok) refreshLingguang()
    })
    watch(() => route.name, () => refreshLingguang())

    const onSelectMenu = (key) => {
      if (key === 'home') router.push({ name: 'home' })
      if (key === 'ai-draw') router.push({ name: 'ai-draw' })
      if (key === 'draw-styles-settings') router.push({ name: 'draw-styles-settings' })
      if (key === 'prompts') router.push({ name: 'prompts' })
      if (key === 'knowledge') router.push({ name: 'knowledge' })
      if (key === 'admin') router.push({ name: 'admin' })
    }
    
    const handleUserCommand = async (command) => {
      switch (command) {
        case 'settings':
          router.push({ name: 'settings' })
          break
          
        case 'logout':
          try {
            await ElMessageBox.confirm(
              '确定要退出登录吗？',
              '确认',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              }
            )
            
            await authService.logout()
            userStore.logout()
            ElMessage.success('已退出登录')
            router.push({ name: 'portal' })
            
          } catch (error) {
            if (error !== 'cancel') {
              console.error('登出失败:', error)
              userStore.logout()
              router.push({ name: 'portal' })
            }
          }
          break
      }
    }
    
    return {
      userStore,
      isManagementShellNav,
      menuActiveIndex,
      onSelectMenu,
      handleUserCommand
    }
  }
}
</script>

<style scoped>
.top-nav {
  height: var(--header-height);
  background: #ffffff;
  border-bottom: 1px solid var(--border);
  padding: 0;
  box-shadow: var(--shadow-sm);
}

.nav-content {
  height: 100%;
  width: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand {
  font-size: 20px;
  font-weight: 600;
  color: var(--accent);
  cursor: pointer;
  user-select: none;
  transition: color 0.2s;
}

.brand:hover {
  color: var(--accent-2);
}

.top-menu {
  flex: 1;
  margin: 0 40px;
  border-bottom: none;
}

.top-menu .el-menu-item {
  border-bottom: 2px solid transparent !important;
  color: var(--text);
  font-weight: 500;
  transition: all 0.2s;
}

.top-menu .el-menu-item:hover {
  background-color: rgba(61, 85, 236, 0.1) !important;
  color: var(--accent) !important;
}

.top-menu .el-menu-item.is-active {
  background-color: transparent !important;
  color: var(--accent) !important;
  border-bottom-color: var(--accent) !important;
}

.user-area {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-btn {
  color: var(--accent);
  font-weight: 500;
}

.admin-btn:hover {
  color: var(--accent-2);
  background-color: rgba(61, 85, 236, 0.1);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background-color 0.2s;
}

.user-info:hover {
  background-color: rgba(61, 85, 236, 0.1);
}

.user-avatar-el {
  flex-shrink: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.user-avatar-el :deep(.el-icon) {
  color: #fff;
}

.user-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  max-width: 140px;
}

.username {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
}

.lg-in-avatar {
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
  line-height: 1.2;
  white-space: nowrap;
}

.dropdown-icon {
  color: var(--muted);
  flex-shrink: 0;
  font-size: 12px;
}


</style>


